import { flattenSharedFooterDisclaimers } from '@utils/sanity';
import { SanityGraphQLResponse } from 'types/sanity';
import { useQuery } from 'villus';
import { VcxLandingPageData } from 'types/sanity/vcx-landing-page';
import { VcxLandingPageQuery } from '@sanity/graphql/queries/vcx-landing-page';
import { villusClient } from '@utils/villus';

type SanityVcxLandingPageResponse = SanityGraphQLResponse<VcxLandingPageData, 'allVcxLandingPage'>;

export async function getVcxLandingPage(): Promise<VcxLandingPageData | null> {
	const { data } = await useQuery<SanityVcxLandingPageResponse>({
		client: villusClient,
		query: VcxLandingPageQuery,
		tags: ['vcx_landing_page']
	}).execute();

	const vcxLandingPage = data?.allVcxLandingPage?.[0] ?? null;

	if (!vcxLandingPage) return null;

	// empty arrays in sanity are served as null - make them null-safe
	vcxLandingPage.vcxPortfolioDescription = vcxLandingPage.vcxPortfolioDescription ?? [];
	vcxLandingPage.vcxPortfolioHoldings = vcxLandingPage.vcxPortfolioHoldings ?? [];
	vcxLandingPage.vcxSectorBreakdown = vcxLandingPage.vcxSectorBreakdown ?? [];
	vcxLandingPage.vcxPrivatePublicBreakdown = vcxLandingPage.vcxPrivatePublicBreakdown ?? [];
	vcxLandingPage.vcxPerformanceData = vcxLandingPage.vcxPerformanceData ?? [];
	vcxLandingPage.vcxFeaturedPodcasts = vcxLandingPage.vcxFeaturedPodcasts ?? [];
	vcxLandingPage.vcxFlatFooterDisclaimer = flattenSharedFooterDisclaimers(vcxLandingPage.vcxFooterDisclaimers ?? []);

	return vcxLandingPage;
}
